import { render } from "./InfoSection.vue?vue&type=template&id=385393db&scoped=true&ts=true"
import script from "./InfoSection.ts?vue&type=script&lang=ts&external"
export * from "./InfoSection.ts?vue&type=script&lang=ts&external"

import "./InfoSection.vue?vue&type=style&index=0&id=385393db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385393db"]])

export default __exports__